import React from "react";
import { Checkbox, Rating, TextField, FormControl, FormControlLabel, RadioGroup, Radio, Button } from "@mui/material";
import { useState, useEffect } from "react";
import { GrFormClose } from "react-icons/gr";
import RegularButton from "../../components/Buttons/RegularButton";
import { useAppSelector } from "../../redux/app/hooks";
import { getSpecificEnumData } from "../../redux/slices/enumSlice";
import { getUserData } from "../../redux/slices/HomeSlice";
import { useGetAllParkingSpaceLocationByLatLongAndCityMutation } from "../../redux/services/parkingsApi";
import { Formik } from "formik";
import { getParkingSpaces } from "../../redux/slices/parkingSlice";
import { useGetParkingTypeDataMutation } from "../../redux/services/parkingTypeApi";
import Loading from "../commons/Loading";
import { getSubCategoryData, getAddressData } from "../../redux/slices/navSlice";
import { useGetEnumDataMutation } from "../../redux/services/enumApi";
import { useLocation } from "react-router-dom";
import moment from 'moment';
import { FaTimesCircle } from "react-icons/fa";
import Hatchback from "../../assets/Hatchback.png"
import Sedan from "../../assets/Sedan.png"
import SUV from "../../assets/SUV.png"



type Props = {
  displays?: boolean;
  setDisplays?: any;
  coords?: any;
  handleFilter?: any;
  favorateData?: any;
  parkingcategoryName?: any;
  selectedPackage?: any
};

const labels: { [index: string]: string } = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};

const Filters = (props: Props) => {
  console.log("selectedpackage", props?.selectedPackage);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const id = useAppSelector(getSubCategoryData);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const parkingType: any = useAppSelector(getUserData);
  const [parkingTypes, setParkingTypes] = useState([]);
  const [parking, setParking] = useState([]);
  const [enumValue, setEnumValue] = useState([]);
  console.log(enumValue ,"enumValue");
  const parkingtype = useAppSelector(getParkingSpaces);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [rowParPage, setRowParPage] = useState(5);
  const [selectedOption, setSelectedOption] = React.useState<string>("lowToHigh");
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };
  const [formValues, setFormValues] = useState({
    minPrice: "",
    maxPrice: "",
    price: '',
    amenities: [],
    parkingTypeId: [],
  });
  const [ratingValue, setRatingValue] = useState(0);

  const [getAllParkingSpaceLocationByLatLongAndCity, AllResponse] =
    useGetAllParkingSpaceLocationByLatLongAndCityMutation();
  const [getParkingTypeData, parkingTypeResponse] =
    useGetParkingTypeDataMutation();
  const [parkingTypeName, setParkingTypeName] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState() as any;
  const location: any = useLocation();
  const tripData: any = JSON.parse(localStorage.getItem("tripDetails") || "{}");
  const [startDate, setStartDate] = useState<Date | null>(
    tripData?.checkIn ? new Date(tripData?.checkIn) : null
  );
  const [endDate, setEndDate] = useState<Date | null>(
    tripData?.checkOut ? new Date(tripData?.checkOut) : null
  );
  const [tripType, setTripType]: any = useState(
    tripData?.TripType ? tripData?.TripType : {}
  );

  const getIsLoggedIn = () => {
    let isLoggedIn: any = localStorage.getItem("isLoggedIn");
    isLoggedIn = JSON.parse(isLoggedIn);
    setIsLoggedIn(isLoggedIn);
  };

  useEffect(() => {
    getIsLoggedIn();
  }, [isLoggedIn]);

  useEffect(() => {
    getParkingTypeData({
      payload: {
        offset: rowParPage,
        pageNumber: page,
        sortOrder: order,
        status: true,
      },
    });
  }, [getParkingTypeData]);

  useEffect(() => {
    if (parkingTypeResponse.isSuccess) {
      let parkingTypeDate: any = parkingTypeResponse.data;
      setParkingTypeName(parkingTypeDate.data);
    }
  }, [parkingTypeResponse.isSuccess]);

  const packageTypeValue = tripData?.packageType || "";

  const [duration, distance] = packageTypeValue.match(/\d+/g) || [0, 0]

  const selectedPackage: string = String(props.selectedPackage || "");

  const [selectedDuration, selectedDistance] = selectedPackage.match(/\d+/g) || [0, 0]

  const fromLocation = tripData.address?.fromLocation || {};
  const toLocation = tripData.address?.toLocation || {};

  const parkingDatas = (values: any) => {
    console.log(values, "values");
    getAllParkingSpaceLocationByLatLongAndCity({
      payload: {
        parkingTypeId: [tripType?.id],
        vehicleType: values.vehicleType,
        priceSortBy: values.price,
        customerId: isLoggedIn ? currentUser.customerId : 0,
        fromLat: fromLocation.lat ?? 0,
        fromLng: fromLocation.lng ?? 0,
        toLat: toLocation.lat ?? 0,
        toLng: toLocation.lng ?? 0,
        checkInTime: startDate ? startDate : tripData.checkIn,
        checkOutTime: tripType.typeName === "OutStation One Way" || tripType.typeName === "Airport Drop"
          ? null
          : tripType.typeName === "OutStation Round Trip"
            ? endDate
            : tripType.typeName === "Hourly Rental" && startDate
              ? moment(startDate)
                .add(
                  parseInt(
                    (selectedPackage?.match(/^(\d+)\s*hrs/)?.[1] || tripData?.packageType?.match(/^(\d+)\s*hrs/)?.[1] || "2"),
                    10
                  ),
                  "hours"
                )
                .toDate()
              : tripData?.checkOut,
        offset: 10,
        page: 0,
        orderBy: 'asc',
        columnName: "id",
        seatingCapacity: tripData.peopleCount,
        luggageCapacity: tripData.luggageCount,
        packageType: props?.selectedPackage ? props?.selectedPackage : tripData.packageType,
        parkingType: tripType.typeName,
        distance: (tripType.typeName === "Hourly Rental") ? (selectedDistance || distance) : null,
        duration: (tripType.typeName === "Hourly Rental") ? (selectedDuration || duration) : null,
      },
    });
  };

  useEffect(() => {
    if (parking) {
      setParking(parking);
    }
  }, [parking]);

  useEffect(() => {
    if (parkingType) {
      setParkingTypes(parkingType);
    }
  }, [parkingType]);

  {/**useEffect(() => {
    if (enumData) {
      setEnumValue(enumData["AMENITIES_TYPE"]);
      console.log("Amenities Types:",enumData);
    }
  }, [enumData]);  */}

  useEffect(() => {
    getEnumData({});
  }, [getEnumData]);

  const vehicleImages: Record<string, string> = {
    Hatchback: Hatchback,
    Sedan: Sedan,
    SUV: SUV,
  };

  useEffect(() => {
    if (enumResponse?.data) {
      const vehicleTypes = enumResponse.data["VEHICLE_TYPE"] || [];

      // Map through the array and assign images
      const updatedVehicleTypes = vehicleTypes.map((vehicle:any) => ({
        ...vehicle,
        imageUrl: vehicleImages[vehicle.displayValue] ,
      }));

      console.log(updatedVehicleTypes, "updatedVehicleTypes");
      setEnumValue(updatedVehicleTypes);
    }
  }, [enumResponse]);



  useEffect(() => {
    if (AllResponse.isSuccess) {
      console.log(AllResponse, "AllResponse");
      props.handleFilter(AllResponse.data);
      props.setDisplays(false);
    }
  }, [AllResponse.isSuccess]);

  return (
    <div className="overflow-x-auto whitespace-nowrap scrollbar-hide">
      {AllResponse.isLoading || parkingTypeResponse.isLoading ? (
        <Loading />
      ) : null}
      <Formik
        enableReinitialize={true}
        initialValues={formValues}
        onSubmit={parkingDatas}
      >
        {({ values, handleChange, handleBlur, handleSubmit }) => (
          <div>
            <h2 className="text-[#58595B] md:text-2xl text-xl font-semibold mt-2">Filter Vehicles</h2>
            <div className="text-[#58595B] mt-8">
              <div className="flex items-center space-x-2  w-full">
                <h4 className="whitespace-nowrap text-[#58595B] md:text-sm text-xs">Vehicle Types</h4>
                <div className="border-b-[1px] border-red-500 flex-grow"></div>
              </div>
              <div className="flex flex-col text-sm ">
                {enumValue.map((enumDatas: any, index: any) => (
                  <div key={index} className="flex items-center gap-2">
                    <Checkbox
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="vehicleType"
                      color="error"
                      value={enumDatas.code}
                      key={enumDatas.code}
                      size="small" // Reduces checkbox size
                      sx={{
                        '& .MuiSvgIcon-root': { fontSize: 18 } // Adjust the icon size further if needed
                      }}
                    />
                    <img src={enumDatas?.imageUrl} alt="Car Icon" className="w-8 h-5" />
                    <h4 className="text-[#58595B] md:text-base text-xs font-semibold">{enumDatas.displayValue}</h4>
                  </div>
                ))}
              </div>
            </div>
            <div>
              {/* Title with underline */}
              <div className="flex items-center space-x-2 text-sm w-full">
                <h4 className="whitespace-nowrap text-[#58595B]">Sort By</h4>
                <div className="border-b-[1px] border-red-500 flex-grow"></div>
              </div>

              {/* Radio buttons for sorting */}
              <div className="ml-3.5">
                <RadioGroup
                  row
                  name="price"
                  value={values.price || ""}
                  onChange={(event) => {
                    console.log("Price selected:", event.target.value);
                    handleChange(event);
                  }}
                  className="mt-2 flex flex-col"
                >
                  <FormControlLabel
                    value="LOW_TO_HIGH"
                    control={
                      <Radio
                        sx={{
                          color: "gray",
                          "&.Mui-checked": { color: "red" },
                          "& .MuiSvgIcon-root": { fontSize: 18 }, // Reduce size
                        }}
                      />
                    }
                    label={<span className="text-sm text-[#58595B] font-semibold">Price (Low to High)</span>}
                  />
                  <FormControlLabel
                    value="HIGH_TO_LOW"
                    control={
                      <Radio
                        sx={{
                          color: "gray",
                          "&.Mui-checked": { color: "red" },
                          "& .MuiSvgIcon-root": { fontSize: 18 }, // Reduce size
                        }}
                      />
                    }
                    label={<span className="text-sm text-[#58595B] font-semibold">Price (High to Low)</span>}
                  />
                </RadioGroup>
              </div>
            </div>
            <div className="flex gap-4 mt-2">
              {/* Cancel Button */}
              <button
                className="md:w-[120px] w-full bg-[#58595B] hover:bg-[#58595B] text-white h-[30px] rounded-[6px] font-semibold px-4"
                onClick={() => props.setDisplays(false)}
              >
                Cancel
              </button>

              {/* Apply Button */}
              <button
                className="md:w-[120px] w-full bg-[#ED1C24] hover:bg-[#ED1C24] text-white h-[30px] rounded-[6px] font-semibold px-4"
                onClick={() => handleSubmit()}
              >
                Apply
              </button>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};
export default Filters;
